import { queries as candidatesQueries } from "domains/hire/containers/Candidates/queries";
import type { CandidatesSearch } from "domains/hire/containers/Candidates/routing";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: { search: CandidatesSearch }): Array<WarmableQuery> => candidatesQueries(input);
